export default __webpack_public_path__ + "static/media/Read-Bold_V1100.47b9d764.woff";